import { render, staticRenderFns } from "./UrlHTML.vue?vue&type=template&id=3380d146&scoped=true&"
import script from "./UrlHTML.vue?vue&type=script&lang=js&"
export * from "./UrlHTML.vue?vue&type=script&lang=js&"
import style0 from "./UrlHTML.vue?vue&type=style&index=0&id=3380d146&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3380d146",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
installComponents(component, {VCard,VCardTitle})
